export default "__VITE_ASSET__a905538f__"